import React, { useMemo } from 'react';

import {
  Flex, GridItem, Text,
} from '@chakra-ui/react';
import {
  LineChart, CartesianGrid, Legend, XAxis, YAxis, Tooltip, Line, ResponsiveContainer,
} from 'recharts';

import colors from 'theme/colors';

const headerTranslation = {
  day: 'Dia',
  week: 'Semana',
  month: 'Mês',
  year: 'Ano',
};

const typeTranslation = {
  day: 'Diário',
  week: 'Semanal',
  month: 'Mensal',
  year: 'Anual',
};

export default function SeasonCost({ data }) {
  const { max, min } = useMemo(() => {
    if (data?.graph) {
      const { materials, patients } = data?.graph.reduce(
        (prev, graph) => {
          prev.materials.push(graph.material);
          prev.patients.push(graph.patient);
          return prev;
        }, { materials: [], patients: [] });
      return {
        min: Math.floor(Math.min(...materials, ...patients) * 0.75),
        max: Math.ceil(Math.max(...materials, ...patients) * 1.25),
      };
    }
    return {
      min: 0,
      max: 0,
    };
  }, [data]);
  return (
    <GridItem
      as={Flex}
      bg="white.default"
      color="gray.50"
      flexDir="column"
      borderRadius={8}
      colSpan={3}>
      <Flex
        p={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px">
        <Text
          variant="xSmallBold"
          color="gray.500">Custos por {headerTranslation[data?.interval]}
        </Text>
        <Text
          variant="2xSmallSemiBold"
          color="gray.400">{typeTranslation[data?.interval]}
        </Text>
      </Flex>
      <Flex
        width="100%"
        p={4}>
        <Flex width="100%">
          <ResponsiveContainer
            height={200}
            width="100%">
            <LineChart
              height={200}
              data={data?.graph}
              margin={{
                top: 5, right: 30, left: 20, bottom: 5,
              }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                tickMargin={8}
                dataKey="date"
              />
              <YAxis
                type="number"
                domain={[min, max]}
              />
              <Tooltip contentStyle={{
                color: 'gray',
              }}
              />
              <Legend />
              <Line
                type="linear"
                name="Custo por Paciente"
                dataKey="patient"
                stroke={colors.primary.default}
              />
              <Line
                type="linear"
                name="Custo por Material"
                dataKey="material"
                stroke={colors.primary[900]}
              />
            </LineChart>
          </ResponsiveContainer>
        </Flex>
      </Flex>
    </GridItem>
  );
}
